import { Navigate } from 'react-router-dom'
import { logout } from '../../lib/allauth'
import React, { useContext, useState } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import { useNavigate } from 'react-router-dom'
import { deactivateUser, deleteUser } from '../../lib/allauth';
import { Button, Box, Typography, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import BaseButton from '../../components/BaseButton'
import BackgroundContainer from '../../components/BackgroundContainer'
import BaseHeader from '../../components/BaseHeader'
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.05rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function Logout () {
  const [response, setResponse] = useState({ fetching: false, content: null })
  const navigate = useNavigate()
  function submit () {
    setResponse({ ...response, fetching: true })
    logout().then((content) => {
      setResponse((r) => { return { ...r, content } })
    }).catch((e) => {
      console.error(e)
      window.alert(e)
    }).then(() => {
      setResponse((r) => { return { ...r, fetching: false } })
    })
  }
  if (response.content) {
    return <Navigate to='/' />
  }
  return (
    <BackgroundContainer>
      <BaseFormContainer>
      <BaseHeader style={{fontSize: '2rem',}}>Logout</BaseHeader>
      <Subtitle sx={{marginBottom : '10px'}}>
        Are you sure you want to logout?
      </Subtitle>
      <Box sx={{display: 'flex'}}>
      <BaseButton sx={{margin: '10px'}} onClick={() => navigate("/")}>Back</BaseButton>
      <BaseButton sx={{margin: '10px'}} disabled={response.fetching} onClick={() => submit()}>Logout</BaseButton>
      </Box>
      </BaseFormContainer>
    </BackgroundContainer>
  )
}
